import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import {
  ICourseHoursRangeItem,
  TCourseHoursRangeType,
  ICourseHoursRange,
} from '.';

const apiDataProvider = new APIDataProvider();

// eslint-disable-next-line import/prefer-default-export
export const getCourseHoursRange = createAsyncThunk(
  '/course-hours-ranges/get-one',
  async (courseType?: TCourseHoursRangeType) => {
    const path = `${ApiPaths.settings}/hours-range?courseType=${courseType}`;
    const response = await apiDataProvider.get<
      TApiResponse<ICourseHoursRangeItem | ICourseHoursRange>
    >(path);

    const responseData = response.data;

    if (
      courseType &&
      responseData &&
      typeof responseData === 'object' &&
      courseType in responseData
    ) {
      return (responseData as ICourseHoursRange)[courseType];
    }

    return responseData as ICourseHoursRangeItem;
  }
);
